import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const AdminRoutes = defineRoute({
    record: {
        route: {
            path: "/admin",
            component: () => loadView(import("./AdminTable.vue")),
        },
    },
    create: {
        route: {
            path: "/admin/create",
            component: () => loadView(import("./AdminCreate.vue")),
        },
    },
    update: {
        route: {
            path: "/admin/update/:id",
            component: () => loadView(import("./AdminUpdate.vue")),
        },
        build(id: string) {
            return `/admin/update/${id}`;
        },
    },
});
